import React, { Component } from 'react'
import {
  ElementsConsumer,
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  PaymentRequestButtonElement
} from '@stripe/react-stripe-js'
import { Stripe, StripeElements } from '@stripe/stripe-js'
import Card from '../components/Card'
import Heading from '../components/Heading'
import Logo from '../components/Logo'
import Row from '../components/Row/Row'
import CardButton from '../components/CardButton'
import alertService from '../services/alert.service'
import LoadingOverlay from '../components/LoadingOverlay/LoadingOverlay'
import { i18n } from '../i18n/i18n'
import subscriptionApi, { SubscriptionPackage, PreviewPlanSubscription } from '../apis/subscriptionApi'
import Icon from '../components/Icon'
import authService from '../services/auth.service'
import Striplogo from '../assets/download.png'
import PoweredByStripe from '../assets/stripe-lower (1).png'

interface Props {
    stripe: Stripe | null;
    elements: StripeElements | null;
    selectedPlan: SubscriptionPackage | null;
    userId: number | string | null;
    onPaymentSuccess: () => void;
}

interface InjectedProps {
    selectedPlan: SubscriptionPackage | null;
    userId: number | string | null;
    onPaymentSuccess: () => void;
}

interface State {
    isLoading: boolean
    cardNumber: string | number
    newPurchasePlan: PreviewPlanSubscription | null
    paymentRequest: any | null
    canMakePayment: boolean
}

const className = 'border border-primary rounded-none outline-none p-4 placeholder:text-center placeholder:text-lg'

class PaymentForm extends Component<Props, State> {
  initialState: State = {
    isLoading: false,
    cardNumber: '',
    newPurchasePlan: null,
    paymentRequest: null,
    canMakePayment: false
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleSubmit2 = this.handleSubmit2.bind(this)
  }

  componentDidMount (): void {
    const authData = authService.tokenData()
    if (!authData) return

    const { id } = authData
    const { stripe, selectedPlan } = this.props

    subscriptionApi.getActiveMembership(id, membership => {
      if (membership?.type === 'trial') {
        if (!selectedPlan) return

        const payload = {
          package_id: selectedPlan.id,
          userId: id,
          isUpgrade: false
        }

        subscriptionApi.getPreviewPlanSubscription(payload, previewPlanSubscription => {
          if (!previewPlanSubscription?.plan_name) return

          this.setState({
            newPurchasePlan: previewPlanSubscription
          })
        })
      }
    })

    if (!stripe || !selectedPlan) return

    const paymentRequest = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: selectedPlan.name,
        amount: Math.round(selectedPlan.price * 100)
      },
      requestPayerName: true,
      requestPayerEmail: true
    })
    console.log('paymentRequest:========' + paymentRequest)

    paymentRequest.canMakePayment().then(result => {
      console.log('result:========' + result)
      if (result) {
        this.setState({
          paymentRequest,
          canMakePayment: true
        })
      }
    }).catch(error => {
      console.log('error:========' + error)
    })

    paymentRequest.on('paymentmethod', async (ev) => {
      subscriptionApi.subscribe({
        package_id: selectedPlan.id,
        payment_method: ev.paymentMethod.id,
        userId: id
      }, () => {
        ev.complete('success')
        this.props.onPaymentSuccess()
      })
    })
  }

  componentDidUpdate (prevProps: Props): void {
    if (!this.props.stripe || !this.props.selectedPlan) return

    // Stripe just became available
    if (this.props.stripe !== prevProps.stripe) {
      this.initPaymentRequest()
    }
  }

  initPaymentRequest () {
    const { stripe, selectedPlan } = this.props
    const authData = authService.tokenData()
    if (!authData || !stripe || !selectedPlan) return

    const { id } = authData

    const paymentRequest = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: selectedPlan.name,
        amount: Math.round(selectedPlan.price * 100)
      },
      requestPayerName: true,
      requestPayerEmail: true
    })

    console.log('paymentRequest:', paymentRequest)

    paymentRequest.canMakePayment()
      .then(result => {
        console.log('canMakePayment result:', result)
        if (result) {
          this.setState({
            paymentRequest,
            canMakePayment: true
          })
        }
      })
      .catch(err => {
        console.error('canMakePayment error:', err)
      })

    paymentRequest.on('paymentmethod', ev => {
      subscriptionApi.subscribe(
        {
          package_id: selectedPlan.id,
          payment_method: ev.paymentMethod.id,
          userId: id
        },
        () => {
          ev.complete('success')
          this.props.onPaymentSuccess()
        }
      )
    })
  }

  handleSubmit2 = async () => {
    this.setState({ isLoading: true })

    const { stripe, elements, selectedPlan, userId, onPaymentSuccess } = this.props

    if (!stripe || !elements) return

    const cardElement = elements.getElement(CardNumberElement)
    if (!cardElement) {
      alertService.warning(i18n('Card element is not loaded'))
      return
    }

    const result = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement
    })

    if (result.error) {
      alertService.warning(result.error.message ?? i18n('Payment failed'))
      this.setState({ isLoading: false })
      return
    }

    if (!selectedPlan) {
      alertService.warning(i18n('No subscription plan selected'))
      this.setState({ isLoading: false })
      return
    }

    try {
      const payload = {
        package_id: selectedPlan.id,
        payment_method: result.paymentMethod.id,
        userId
      }

      subscriptionApi.subscribe(payload, (response) => {
        if (response) {
          alertService.success(i18n('Payment method created!'))
          this.setState({ isLoading: false })
          if (onPaymentSuccess) {
            onPaymentSuccess()
          }
        }
      })
    } catch (error) {
      alertService.warning(
                error as string
      )
      this.setState({ isLoading: false })
    }
  }

  render () {
    const { stripe, selectedPlan } = this.props
    if (!stripe) {
      return <div>{i18n('Loading')}...</div>
    }

    console.log('Can make payment:========' + this.state.canMakePayment)

    return (
            <>
                <Card className='mt-8'>
                    {this.state.isLoading && <LoadingOverlay/>}
                    <div className='flex justify-between'>
                        <div>
                            <Heading
                                text='Welcome to QPRO+'
                                className='text-theme'/>
                            <div className="text-secondary">
                                {i18n('Fill out the form to request')}
                                <br/>
                            </div>
                        </div>
                        <Logo type='icon'/>
                    </div>

                    {/* PLAN CARD */}
                    <div className="subscription-container w-80 flex-shrink-0"
                         style={{ marginTop: '40px', marginBottom: '40px' }}>

                        {
                            this.state.newPurchasePlan
                            // eslint-disable-next-line multiline-ternary
                              ? (
                                    <div className="shadow-md p-6 subscription-card">
                                        <div className="text-xs font-bold uppercase tracking-wide mb-2">
                                            {i18n('Updated Plan')}
                                        </div>

                                        <h3 className="text-lg font-medium mb-4">
                                            {this.state.newPurchasePlan.plan_name}
                                        </h3>

                                        <div className="text-sm mb-2">
                                            {i18n('Remaining days')}: {this.state.newPurchasePlan.remaining_days}
                                        </div>

                                        <div className="text-sm mb-2">
                                            {i18n('Credit applied')}: ${this.state.newPurchasePlan.credit}
                                        </div>

                                        <div className="flex items-baseline gap-1 font-medium">
                <span className="text-4xl">
                    ${this.state.newPurchasePlan.total_due_now}
                </span>
                                            <span className="text-base">
                    {i18n('Due now')}
                </span>
                                        </div>

                                        <div className="text-xs mt-3 text-secondary">
                                            {i18n('Next cycle')}:
                                            ${this.state.newPurchasePlan.next_cycle_total} on {this.state.newPurchasePlan.renewal_date}
                                        </div>
                                    </div>
                                ) : (
                            /* Otherwise → normal selectedPlan */
                                  selectedPlan && (
                                        <div className="shadow-md p-6 subscription-card">
                                            <div className="text-xs font-bold uppercase tracking-wide mb-2">
                                                {i18n('Selected Plan')}
                                            </div>

                                            <h3 className="text-lg font-medium mb-4">
                                                {selectedPlan.name}
                                            </h3>

                                            <div className="flex items-baseline gap-1 font-medium">
                    <span className="text-4xl">
                        ${selectedPlan.price}
                    </span>
                                                <span className="text-base">
                        /{selectedPlan.time}
                    </span>
                                            </div>
                                        </div>
                                  )
                                )}
                    </div>

                    <div className="w-1/2 border border-solid border-primary p-5 mb-4 rounded-md">

                        {/* Card Header */}
                        <div className="flex items-center mb-4">
                            <img src={PoweredByStripe} alt="Powered by Stripe" className="h-16 w-auto"/>
                        </div>

                        <div className="flex gap-2 items-center mb-2">
                            <Icon
                                name="bank-card-line"
                                className="ri-bank-card-line text-primary"
                                size="small"
                             color="dark"/>
                            <Heading text="Card" className="text-theme"/>
                        </div>

                        <div className="text-secondary text-sm mb-4">
                            Secure, fast checkout with Link
                        </div>

                        {/* Card Inputs */}
                        <div className="mb-4">
                            <label className="block mb-1 text-sm">Card Number</label>
                            <CardNumberElement className={className}/>
                        </div>

                        <div className="flex gap-3 mb-4">
                            <div className="flex-1">
                                <label className="block mb-1 text-sm">Expiry</label>
                                <CardExpiryElement className={className}/>
                            </div>

                            <div className="flex-1">
                                <label className="block mb-1 text-sm">CVC</label>
                                <CardCvcElement className={className}/>
                            </div>
                        </div>
                        {/* Wallets */}
                        {this.state.canMakePayment && (
                            <>
                                <div className="relative my-5">
                                    <div className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-300"></div>
                                    </div>
                                    <div className="relative flex justify-center">
    <span className="bg-white px-3 text-xs text-gray-500 uppercase tracking-wide">
      Or
    </span>
                                    </div>
                                </div>

                                <div className="my-4">
                                    <PaymentRequestButtonElement
                                        options={{ paymentRequest: this.state.paymentRequest }}
                                        className="w-full"
                                    />
                                </div>
                            </>
                        )}

                    </div>

                    <Row column={2}>
                        <CardButton
                            proceedText={i18n('Pay now')}
                            onProceedClick={this.handleSubmit2}/>
                    </Row>
                </Card>
            </>
    )
  }
}

export default function InjectedCheckoutForm ({ selectedPlan, userId, onPaymentSuccess }: InjectedProps) {
  return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <PaymentForm
                    stripe={stripe}
                    elements={elements}
                    selectedPlan={selectedPlan}
                    userId={userId}
                    onPaymentSuccess={onPaymentSuccess}
                />
            )}
        </ElementsConsumer>
  )
}
